import { render, staticRenderFns } from "./header.vue?vue&type=template&id=0a2d60bd&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
import style0 from "./header.vue?vue&type=style&index=0&id=0a2d60bd&prod&lang=scss"
import style1 from "./header.vue?vue&type=style&index=1&id=0a2d60bd&prod&scoped=true&lang=css"
import style2 from "./header.vue?vue&type=style&index=2&id=0a2d60bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2d60bd",
  null
  
)

export default component.exports